// Activity timeline — "Regina 报废了 3 个 草莓 @ RH · 5月23日 14:30".
// Used in two places:
//   - /inventory bottom: compact preview (last 5) with 查看全部 link
//   - /inventory/activity: full feed with filters
//
// Uses the .inv-feed timeline visual from inventory-grid.css (vertical line +
// colored dot per kind, action verb + qty bolded, timestamp right-aligned).

import { navigate } from '../lib/routing.js';
import { displayName } from '../lib/products.ts';

const KIND_VERB = {
  produced: '生产了',
  received: '收货',
  sold: '售出了',
  wasted: '报废了',
  transferred: '调拨了',
  adjusted: '调整了'
};
const WEEKDAY_ZH = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

// Format as "5月23日(周六) 14:30" (local time so it matches Regina's wall clock).
export function formatActivityTime(iso) {
  if (!iso) return '';
  const d = new Date(iso.replace(' ', 'T') + (iso.endsWith('Z') ? '' : 'Z'));
  if (isNaN(d.getTime())) return iso;
  const M = d.getMonth() + 1;
  const D = d.getDate();
  const wd = WEEKDAY_ZH[d.getDay()];
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${M}月${D}日(${wd}) ${hh}:${mm}`;
}

/**
 * One row in the activity timeline.
 */
export const ActivityItem = ({ e }) => {
  const verb = KIND_VERB[e.kind] || e.kind;
  const qty = Math.abs(e.qty);
  const product = e.productName
    ? displayName({ name: e.productName, category: null })  // we don't have category here
    : e.productId;
  const actor = e.actorName || '系统';
  // Transfers come through as TWO rows (source -qty, dest +qty) sharing a
  // transfer_group_id. Tag direction so the feed is readable.
  let suffix = `@ ${e.location}`;
  if (e.kind === 'transferred') {
    suffix = e.qty < 0 ? `(${e.location} 出)` : `(→ ${e.location} 入)`;
  }
  const reason = e.reason ? ` · ${e.reason}` : '';
  return (
    <li className={`inv-feed-item ${e.kind}`}>
      <strong>{actor}</strong> {verb} <strong>{qty}</strong> 件 {product}{' '}
      <span className="vava-hint">{suffix}{reason}</span>
      <span className="inv-feed-time">{formatActivityTime(e.createdAt)}</span>
    </li>
  );
};

/**
 * Compact activity feed for /inventory (last 5 events).
 * Includes a 查看全部 link that navigates to /inventory/activity.
 */
export const ActivityFeedCompact = ({ events, title = '最近活动', emptyHint }) => {
  const recent = (events || []).slice(0, 5);
  return (
    <div className="vava-card inv-activity-card">
      <div className="inv-activity-head">
        <h2>{title}</h2>
        <button className="inv-activity-link"
                onClick={() => navigate('/inventory/activity')}>
          查看全部 →
        </button>
      </div>
      {recent.length === 0 ? (
        <div className="vava-hint">{emptyHint || '暂无记录。在主表点任意单元格录入第一条。'}</div>
      ) : (
        <ul className="inv-feed">
          {recent.map(e => <ActivityItem key={e.id} e={e} />)}
        </ul>
      )}
    </div>
  );
};
